import mrpHeroBannerTitleStyle from '../nap/heroBannerTitle'

export default {
  ...mrpHeroBannerTitleStyle,
  loyaltyFontStyle: {
    fontWeight: 700,
    fontSize: '26px',
    lineHeight: '32.5px',
    textAlign: 'center',
    'screen-large': {
      fontSize: '34px',
      lineHeight: '42.5px',
      textAlign: 'center'
    }
  }
}
